import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Registro: React.FC = () => {
  const [formValues, setFormValues] = useState({
    nombre: '',
    apellido: '',
    segundoApellido: '',
    tipoDocumento: '',
    numeroDocumento: '',
    fechaNacimiento: '',
    paisNacimiento: '',
    departamento: '',
    ciudad: '',
    direccion: '',
    genero: '',
    estadoCivil: '',
    correoElectronico: '',
    telefono: '',
    foto: '',
    cargo: '',       // Nuevo campo
    salario: '',     // Nuevo campo
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault(); // Previene el envío del formulario por defecto

    // Validación de campos requeridos
    for (const key in formValues) {
      if (formValues[key as keyof typeof formValues] === '') {
        toast.error(`El campo ${key} es requerido.`); // Muestra mensaje de error
        return;
      }
    }

    // Envío de datos si todos los campos son válidos
    axios.post('http://localhost:3004/register', formValues)
      .then(response => {
        console.log('Formulario enviado:', response.data);
        toast.success('Datos enviados con éxito');  // Muestra mensaje de éxito
        handleClear();  // Limpia el formulario después del envío
      })
      .catch(error => {
        console.error('Error al enviar el formulario:', error);
        toast.error('Hubo un error al enviar los datos');  // Muestra mensaje de error
      });
  };

  const handleClear = () => {
    setFormValues({
      nombre: '',
      apellido: '',
      segundoApellido: '',
      tipoDocumento: '',
      numeroDocumento: '',
      fechaNacimiento: '',
      paisNacimiento: '',
      departamento: '',
      ciudad: '',
      direccion: '',
      genero: '',
      estadoCivil: '',
      correoElectronico: '',
      telefono: '',
      foto: '',
      cargo: '',       // Nuevo campo
      salario: '',     // Nuevo campo
    });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white flex flex-col justify-start items-center">
      <div className="w-full max-w-8xl bg-white rounded-lg shadow-lg p-8 mt-4">
        <h2 className="text-2xl font-bold mb-4">Registro</h2>
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-gray-700 mb-1">Nombre</label>
              <input
                type="text"
                name="nombre"
                value={formValues.nombre}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Apellido</label>
              <input
                type="text"
                name="apellido"
                value={formValues.apellido}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Segundo Apellido</label>
              <input
                type="text"
                name="segundoApellido"
                value={formValues.segundoApellido}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Tipo de Documento</label>
              <select
                name="tipoDocumento"
                value={formValues.tipoDocumento}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              >
                <option value="">Tipo de Documento</option>
                <option value="Cédula de Ciudadanía">Cédula de Ciudadanía</option>
                <option value="Pasaporte">Pasaporte</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Número de Documento</label>
              <input
                type="text"
                name="numeroDocumento"
                value={formValues.numeroDocumento}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Fecha de Nacimiento</label>
              <input
                type="date"
                name="fechaNacimiento"
                value={formValues.fechaNacimiento}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Departamento</label>
              <input
                type="text"
                name="departamento"
                value={formValues.departamento}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Ciudad</label>
              <input
                type="text"
                name="ciudad"
                value={formValues.ciudad}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Dirección</label>
              <input
                type="text"
                name="direccion"
                value={formValues.direccion}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">País de Nacimiento</label>
              <select
                name="paisNacimiento"
                value={formValues.paisNacimiento}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              >
                <option value="">País de Nacimiento</option>
                <option value="Colombia">Colombia</option>
                <option value="Otro">Otro</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Género</label>
              <select
                name="genero"
                value={formValues.genero}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              >
                <option value="">Género</option>
                <option value="Masculino">Masculino</option>
                <option value="Femenino">Femenino</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Estado Civil</label>
              <select
                name="estadoCivil"
                value={formValues.estadoCivil}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              >
                <option value="">Estado Civil</option>
                <option value="Soltero">Soltero</option>
                <option value="Casado">Casado</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Correo Electrónico</label>
              <input
                type="email"
                name="correoElectronico"
                value={formValues.correoElectronico}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Teléfono</label>
              <input
                type="text"
                name="telefono"
                value={formValues.telefono}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Foto</label>
              <input
                type="file"
                name="foto"
                onChange={handleChange}
                className="border p-3 rounded-lg w-full"
              />
            </div>

            {/* Nuevos campos de Cargo y Salario */}
            <div>
              <label className="block text-gray-700 mb-1">Cargo</label>
              <input
                type="text"
                name="cargo"
                value={formValues.cargo}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Salario</label>
              <input
                type="number"
                name="salario"
                value={formValues.salario}
                onChange={handleChange}
                required
                className="border p-3 rounded-lg w-full"
              />
            </div>
          </div>

          <div className="flex justify-between mt-8">
            <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-full">
              Enviar
            </button>
            <button type="button" onClick={handleClear} className="bg-red-500 text-white px-4 py-2 rounded-full">
              Borrar Todo
            </button>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Registro;
